import { useSession, useThreads } from '@/services/queries';

/** Unread messages for the signed-in user (badge on Messages and Profil): the sum over the conversations. */
export function useUnreadCount(): number {
  const { data: user } = useSession();
  const { data: threads } = useThreads(!!user);
  return user ? (threads ?? []).reduce((n, t) => n + (t.unreadCount ?? (t.unread ? 1 : 0)), 0) : 0;
}
